export default __webpack_public_path__ + "dist/media/Add-member.c1433ac5.svg";